// ------------------------------------------------------------------------------
// name: constants
// author: mudas
// created: 2025/8/14
// ------------------------------------------------------------------------------

// 活动资源的CDN根地址
// 开发阶段资源放在 public/activity-center 下进行调测
export const CDN_URL =
  process.env.NODE_ENV === 'development' ? '' : 'https://static.fuxi.netease.com/fuxi-art-platform/theme-dark-light';
